export default __webpack_public_path__ + "static/media/undraw_Maintenance_re_59vn.67412c7a.svg";